import React from 'react';
import { usePathname } from 'next/navigation';

// Define the shape of the returned object
interface AlternateLanguage {
  language: string;
  url: string;
}

const useAlternateLanguages = (): AlternateLanguage[] => {
  const [languages, setLanguages] = React.useState<AlternateLanguage[]>([]);
  const pathname = usePathname();

  React.useEffect(() => {
    // Select all <link rel="alternate"> elements
    const links = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="alternate"]'));

    // Map to objects, filter out invalid entries
    const langs = links
      .map((link) => {
        const hreflang = link.getAttribute('hreflang');
        const href = link.href;
        // Exclude x-default or missing hreflang
        if (!hreflang || hreflang === 'x-default') return null;
        return {
          language: hreflang.toUpperCase(),
          url: href,
        };
      })
      .filter((item): item is AlternateLanguage => item !== null);

    // If "EN" exists, move it to the front
    const hasEn = langs.some((item) => item.language.toLowerCase() === 'en');
    const sorted = hasEn
      ? [
          ...langs.filter((item) => item.language.toLowerCase() === 'en'),
          ...langs.filter((item) => item.language.toLowerCase() !== 'en'),
        ]
      : langs;

    setLanguages(sorted);
  }, [pathname]);

  return languages;
};

export default useAlternateLanguages;
